export const realTimeProgressZh = {
  header: {
    title: '实时进度',
    desc: '查看短信发送任务的实时处理进度和状态',
  },
  actions: {
    search: '搜索',
    reset: '重置',
    export: '导出',
    view: '查看',
    batchDetail: '批次详情',
  },
  table: {
    title: '任务列表',
    recordsCount: '共 {n} 条记录',
    totalRecords: '共 {n} 条记录',
    headers: {
      taskId: '任务ID',
      sendCount: '发送数量',
      success: '成功',
      failed: '失败',
      progress: '进度',
      status: '状态',
      country: '国家',
      senderId: 'SenderID',
      createTime: '创建时间',
      action: '操作',
    },
  },
  status: {
    allStatus: '全部状态',
    processing: '处理中',
    completed: '已完成',
    failed: '已失败',
  },
}

export const realTimeProgressEn = {
  header: {
    title: 'Live Progress',
    desc: 'Track real-time processing progress and status of SMS sending tasks',
  },
  actions: {
    search: 'Search',
    reset: 'Reset',
    export: 'Export',
    view: 'View',
    batchDetail: 'Batch Details',
  },
  table: {
    title: 'Task List',
    recordsCount: '{n} records',
    totalRecords: '{n} records',
    headers: {
      taskId: 'Task ID',
      sendCount: 'Sent',
      success: 'Success',
      failed: 'Failed',
      progress: 'Progress',
      status: 'Status',
      country: 'Country',
      senderId: 'Sender ID',
      createTime: 'Created',
      action: 'Action',
    },
  },
  status: {
    allStatus: 'All Statuses',
    processing: 'Processing',
    completed: 'Completed',
    failed: 'Failed',
  },
}

export const realTimeProgressJa = {
  header: {
    title: 'リアルタイム進捗',
    desc: 'SMS送信タスクのリアルタイム処理進捗とステータスを確認',
  },
  actions: {
    search: '検索',
    reset: 'リセット',
    export: 'エクスポート',
    view: '表示',
    batchDetail: 'バッチ詳細',
  },
  table: {
    title: 'タスク一覧',
    recordsCount: '{n} 件',
    totalRecords: '{n} 件',
    headers: {
      taskId: 'タスクID',
      sendCount: '送信数',
      success: '成功',
      failed: '失敗',
      progress: '進捗',
      status: 'ステータス',
      country: '国',
      senderId: 'Sender ID',
      createTime: '作成日時',
      action: '操作',
    },
  },
  status: {
    allStatus: 'すべてのステータス',
    processing: '処理中',
    completed: '完了',
    failed: '失敗',
  },
}
